// userSaga.js
import { call, put, takeEvery } from "redux-saga/effects";
import { GET_USER } from "./actionTypes";
import { getUserUpload, getUserFailure } from "./actions";
import { getTasks } from "helpers/fakebackend_helper"; // Adjust this based on your API

function* fetchTasks(action) {
  // try {
  //   // Optionally use action.payload (the user) in your API call if needed.
  //   const response = yield call(getTasks);
  //   yield put(getUserUpload(response));
  // } catch (error) {
  //   yield put(getUserFailure(error));
  // }
}

function* userSaga() {
  yield takeEvery(GET_USER, fetchTasks);
}

export default userSaga;
